import React from "react";
const Footer = () => {
    return (
<div>
<div class="footer-padding"></div>
  <div class="footer">
    <p>Copyright @2022</p>
  </div></div>
    )
};
export default Footer
